import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import FlodeskForm from './FlodeskForm';
import AirtableForm from './AirtableForm';

const root = ReactDOM.createRoot(document.getElementById('gratitude-garland-root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
